// Auto-generated per-query builders for Thread
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ThreadReadAPI, ThreadWriteAPI, ThreadReadAPISchema, ThreadWriteAPISchema } from '../types/thread';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ContributesTo, CreatedBy, DesignsPackage, HasContext, HasSteps, HasThread, HasThreads } from '../../relationships/relationship';

import { ModelRequest } from './modelrequest';
import { Step } from './step';
import { Task } from '../../tasks/api/task';
import { ScopedNode } from '../../shared/api/scopednode';
import { SecurityScope } from '../../shared/api/securityscope';
import { Workspace } from '../../base/api/workspace';
import { User } from '../../base/api/user';
import { MBSE_Package } from '../../mbse/api/mbse_package';
import { ThreadTask } from '../../llm_task/api/threadtask';



// Field names for order_by on ModelRequest
type ModelRequestFields = "created_at" | "-created_at" | "order_index" | "-order_index";

// Field names for order_by on Step
type StepFields = "created_at" | "-created_at" | "role" | "-role";

// Field names for order_by on Thread
type ThreadFields = "created_at" | "-created_at" | "name" | "-name" | "status" | "-status";


// Include spec for query: ChatThreadWithIncludesIncludeSpec
export interface ChatThreadWithIncludesIncludeSpec {
  steps?: {
    _limit?: number;  // max 100
    _filter?: { role?: any; text?: any };
    _order_by?: ("created_at" | "created_at_ts")[];
    model_requests?: {
      _limit?: number;  // max 50
      _filter?: { agent_name?: any; order_index?: any };
      _order_by?: ("created_at" | "order_index")[];
      model_response?: {
        _limit?: number;  // max 1
        parts?: {
          _limit?: number;  // max 100
          _filter?: { order_index?: any; part_type?: any };
          _order_by?: ("order_index")[];
        };
      };
      system_prompt?: {
        _limit?: number;  // max 1
      };
    };
    context_items?: {
      _limit?: number;  // max 50
    };
  };
}

// Include spec for query: TasksWorkspaceThreadsIncludeSpec
export interface TasksWorkspaceThreadsIncludeSpec {
  task?: {
    currently_attached_to?: {
    };
  };
}


// Builder chain for query: chat-thread-by-id

export interface ChatThreadByIdBuilder_0 {
  get(id: string): ChatThreadByIdBuilder_1;
  filter(conditions: { id: string }): ChatThreadByIdBuilder_1;
}

export interface ChatThreadByIdBuilder_1 {
  all(): Promise<Thread[]>;
  first(): Promise<Thread | null>;
  get(): Promise<Thread[]>;
  execute(): Promise<Thread[]>;
}

// Builder chain for query: chat-thread-with-includes

export interface ChatThreadWithIncludesBuilder_0 {
  get(id: string): ChatThreadWithIncludesBuilder_1;
  filter(conditions: { id: string }): ChatThreadWithIncludesBuilder_1;
}

export interface ChatThreadWithIncludesBuilder_1 {
  load(include: ChatThreadWithIncludesIncludeSpec): ChatThreadWithIncludesBuilder_1;
  all(): Promise<Thread[]>;
  first(): Promise<Thread | null>;
  get(): Promise<Thread[]>;
  execute(): Promise<Thread[]>;
}

// Builder chain for query: chat-thread-with-steps

export interface ChatThreadWithStepsBuilder_0 {
  get(id: string): ChatThreadWithStepsBuilder_1;
  filter(conditions: { id: string }): ChatThreadWithStepsBuilder_1;
}

export interface ChatThreadWithStepsBuilder_1 {
  steps: ChatThreadWithStepsBuilder_2;
}

export interface ChatThreadWithStepsBuilder_2 {
  filter(conditions: { role?: string }): ChatThreadWithStepsBuilder_2;
}

export interface ChatThreadWithStepsBuilder_2 {
  orderBy(field?: StepFields): ChatThreadWithStepsBuilder_2;
}

export interface ChatThreadWithStepsBuilder_2 {
  limit(value?: number): ChatThreadWithStepsBuilder_2;
  all(): Promise<Step[]>;
  first(): Promise<Step | null>;
  get(): Promise<Step[]>;
  execute(): Promise<Step[]>;
}

// Builder chain for query: chat-thread-steps-requests

export interface ChatThreadStepsRequestsBuilder_0 {
  get(id: string): ChatThreadStepsRequestsBuilder_1;
  filter(conditions: { id: string }): ChatThreadStepsRequestsBuilder_1;
}

export interface ChatThreadStepsRequestsBuilder_1 {
  steps: ChatThreadStepsRequestsBuilder_2;
}

export interface ChatThreadStepsRequestsBuilder_2 {
  filter(conditions: { role?: string }): ChatThreadStepsRequestsBuilder_2;
  model_requests: ChatThreadStepsRequestsBuilder_3;
}

export interface ChatThreadStepsRequestsBuilder_2 {
  model_requests: ChatThreadStepsRequestsBuilder_3;
}

export interface ChatThreadStepsRequestsBuilder_3 {
  orderBy(field?: ModelRequestFields): ChatThreadStepsRequestsBuilder_3;
  all(): Promise<ModelRequest[]>;
  first(): Promise<ModelRequest | null>;
  get(): Promise<ModelRequest[]>;
  execute(): Promise<ModelRequest[]>;
}

// Builder chain for query: tasks-workspace-threads

export interface TasksWorkspaceThreadsBuilder_0 {
  filter(conditions: { id: string }): TasksWorkspaceThreadsBuilder_1;
}

export interface TasksWorkspaceThreadsBuilder_1 {
  orderBy(field?: ThreadFields): TasksWorkspaceThreadsBuilder_1;
}

export interface TasksWorkspaceThreadsBuilder_1 {
  limit(value?: number): TasksWorkspaceThreadsBuilder_1;
  load(include: TasksWorkspaceThreadsIncludeSpec): TasksWorkspaceThreadsBuilder_1;
  all(): Promise<Thread[]>;
  first(): Promise<Thread | null>;
  get(): Promise<Thread[]>;
  execute(): Promise<Thread[]>;
}


// Union of all query entry points
export type ThreadQueryBuilder = ChatThreadByIdBuilder_0 | ChatThreadWithIncludesBuilder_0 | ChatThreadWithStepsBuilder_0 | ChatThreadStepsRequestsBuilder_0 | TasksWorkspaceThreadsBuilder_0;

// Available query names for .setQuery()
export type ThreadQueryNames = "chat-thread-by-id" | "chat-thread-with-includes" | "chat-thread-with-steps" | "chat-thread-steps-requests" | "tasks-workspace-threads";

// Type narrowing for .setQuery()
export type ThreadBuilderForQuery<Q extends ThreadQueryNames> =
  Q extends "chat-thread-by-id" ? ChatThreadByIdBuilder_0
  : Q extends "chat-thread-with-includes" ? ChatThreadWithIncludesBuilder_0
  : Q extends "chat-thread-with-steps" ? ChatThreadWithStepsBuilder_0
  : Q extends "chat-thread-steps-requests" ? ChatThreadStepsRequestsBuilder_0
  : Q extends "tasks-workspace-threads" ? TasksWorkspaceThreadsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ThreadInstanceQueryResult<Q extends ThreadQueryNames> =
  Q extends "chat-thread-by-id" ? ChatThreadByIdBuilder_1
  : Q extends "chat-thread-with-includes" ? ChatThreadWithIncludesBuilder_1
  : Q extends "chat-thread-with-steps" ? ChatThreadWithStepsBuilder_1
  : Q extends "chat-thread-steps-requests" ? ChatThreadStepsRequestsBuilder_1
  : Q extends "tasks-workspace-threads" ? TasksWorkspaceThreadsBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'chat-thread-with-includes',
  'steps|filter|order_by|limit': 'chat-thread-with-steps',
  'steps|filter|model_requests|order_by': 'chat-thread-steps-requests',
  'filter|order_by|limit': 'tasks-workspace-threads',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ThreadQueryNames>(queryName: Q): ThreadBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'model_requests', {
  get() {
    return new QueryBuilderImpl('ModelRequest', [...this.path, 'model_requests'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(QueryBuilderImpl.prototype, 'steps', {
  get() {
    return new QueryBuilderImpl('Step', [...this.path, 'steps'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface Thread extends Partial<ThreadReadAPI> {}
export class Thread extends NeoNodeBase<ThreadReadAPI, ThreadWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Thread";
  static readonly readSchema = ThreadReadAPISchema;
  static readonly writeSchema = ThreadWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    workspace: { target: "Workspace", cardinality: "one", isParent: false, relClass: "HasThreads", direction: "in" },
    task: { target: "Task", cardinality: "one", isParent: true, relClass: "HasThread", direction: "in" },
    created_by: { target: "User", cardinality: "one", isParent: false, relClass: "CreatedBy", direction: "out" },
    context_items: { target: "ScopedNode", cardinality: "many", isParent: false, relClass: "HasContext", direction: "out" },
    steps: { target: "Step", cardinality: "many", isParent: false, relClass: "HasSteps", direction: "out" },
    dev_package: { target: "MBSE_Package", cardinality: "one", isParent: false, relClass: "DesignsPackage", direction: "out" },
    chat_tasks: { target: "ThreadTask", cardinality: "many", isParent: false, relClass: "ContributesTo", direction: "in" },
  };

  protected get modelName(): string {
    return 'Thread';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Thread.label;
  }


  constructor(data: Partial<ThreadWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ThreadReadAPI, loadContext?: Record<string, any>): Thread {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { created_by, context_items, steps, security_scope, workspace, task, dev_package, chat_tasks, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ThreadReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, created_by: created_by, context_items: context_items, steps: steps, security_scope: security_scope, workspace: workspace, task: task, dev_package: dev_package, chat_tasks: chat_tasks };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Thread.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'created_by', 'User', ModelRegistry);
    loadManyRelationship(processed, 'context_items', 'ScopedNode', ModelRegistry);
    loadManyRelationship(processed, 'steps', 'Step', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'workspace', 'Workspace', ModelRegistry);
    loadOneRelationship(processed, 'task', 'Task', ModelRegistry);
    loadOneRelationship(processed, 'dev_package', 'MBSE_Package', ModelRegistry);
    loadManyRelationship(processed, 'chat_tasks', 'ThreadTask', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Thread(processed as any);

    return instance;
  }

  static filter(conditions: { id: string }): TasksWorkspaceThreadsBuilder_0;

  static filter(conditions: Record<string, any>): ThreadQueryBuilder;

  static filter(conditions: Record<string, any>): ThreadQueryBuilder {
    return new QueryBuilderImpl('Thread').filter(conditions) as any;
  }

  static all(): ThreadQueryBuilder {
    return new QueryBuilderImpl('Thread') as any;
  }

  static async first(): Promise<Thread | null> {
    const results = await new QueryBuilderImpl('Thread').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ThreadQueryNames>(queryName: Q): ThreadBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Thread');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ThreadQueryNames>(queryName: Q): ThreadInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Thread.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const thread = await Thread.get(id).first();
   * await thread.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await thread.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'task' - Python ORM style (cached)
  get task(): RelationshipManager<this, Task> {
    return this.getOrCreateRelationshipManager('task', () => {
      return new RelationshipManager(this, 'task', 'one', HasThread as typeof Relationship);
    });
  }

  // Relationship manager for 'context_items' - Python ORM style (cached)
  get context_items(): RelationshipManager<this, ScopedNode> {
    return this.getOrCreateRelationshipManager('context_items', () => {
      return new RelationshipManager(this, 'context_items', 'many', HasContext as typeof Relationship);
    });
  }

  // Relationship manager for 'steps' - Python ORM style (cached)
  get steps(): RelationshipManager<this, Step> {
    return this.getOrCreateRelationshipManager('steps', () => {
      return new RelationshipManager(this, 'steps', 'many', HasSteps as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'workspace' - Python ORM style (cached)
  get workspace(): RelationshipManager<this, Workspace> {
    return this.getOrCreateRelationshipManager('workspace', () => {
      return new RelationshipManager(this, 'workspace', 'one', HasThreads as typeof Relationship);
    });
  }

  // Relationship manager for 'created_by' - Python ORM style (cached)
  get created_by(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('created_by', () => {
      return new RelationshipManager(this, 'created_by', 'one', CreatedBy as typeof Relationship);
    });
  }

  // Relationship manager for 'dev_package' - Python ORM style (cached)
  get dev_package(): RelationshipManager<this, MBSE_Package> {
    return this.getOrCreateRelationshipManager('dev_package', () => {
      return new RelationshipManager(this, 'dev_package', 'one', DesignsPackage as typeof Relationship);
    });
  }

  // Relationship manager for 'chat_tasks' - Python ORM style (cached)
  get chat_tasks(): RelationshipManager<this, ThreadTask> {
    return this.getOrCreateRelationshipManager('chat_tasks', () => {
      return new RelationshipManager(this, 'chat_tasks', 'many', ContributesTo as typeof Relationship);
    });
  }

}
